<template>
    <div v-if="displayLoader" class="gt-groupcard-loader" style="z-index: 99999999;">
        <img :src="$getAssetUrlPlugin('siteres/gt-loader.gif')" alt="Loading" />
        <p>
            Just a moment, we're creating your collection.
        </p>
    </div>

    <div v-if="isdecline">
        <header class="receipt-page-header">
            <div class="container">
                <div class="row">
                    <div class="col-sm-12">
                        <div class="logo">
                            <a href="/Home/Index"><img width="150" :src="$getAssetUrlPlugin('siteres/gt-logo-b.svg')" alt="" title="logo" /></a>
                        </div>
                    </div>
                </div>
            </div>
        </header>
        <div class="mt-receipt-page text-center">
            <div class="mt-receipt-page-inner">
                <h1 id="thank-you-header">Thanks for letting us know!</h1>
                <p>We have noted your response, and have removed you from the reminder list.</p>
            </div>
        </div>

    </div>
    <div v-if="!isdeclinee">
        <div v-if="dnone" class="preview-modal-v2" @click="ShowhideDnone">
            <!--<div class="preview-modal-btn-right">

                <a href="javascript:void(0)">
                    <svg width="16" height="28" viewBox="0 0 16 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M2 26L14 14L2 2" stroke="#1E2437" stroke-width="4" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                </a>

            </div>-->
            <!-- preview-modal-btn-right -->
            <!--<section class="invite-preview-header preview-topheader">
                <div class="row">
                    <div class="col-md-4">

                    </div>-->
            <!-- col-md-6 -->
            <!--<div class="col-md-8 d-flex align-items-center">
                <div class="invite-preview-right">
                    <button type="submit" class="theme-btn-lite">Publish & share</button>
                </div>-->
            <!-- col-md-6 -->
            <!--</div>
                </div>
            </section>-->

            <h2>Hey There, I'm just a preview of what people will see. You can't edit me here or enter your information. Click to exit.</h2>

            <!--<div class="preview-bubble">
                <p>Hey there, I’m just a preview. <br /> Click <b>Publish & share</b> to create your collection. <br /> Click the side arrows to see what you’ve setup.</p>
            </div>

            <div class="pointer-up">
                <p>☝️</p>
            </div>

            <div class="pointer-right">
                <p>👉</p>
            </div>-->

        </div>

        <div v-else class="preview-modal-v2 d-none" @click="ShowhideDnone">
            <div class="preview-modal-btn-right">

                <!--<a href="javascript:void(0)">
                        <svg width="16" height="28" viewBox="0 0 16 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M2 26L14 14L2 2" stroke="#1E2437" stroke-width="4" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                    </a>

                </div>-->
                <!-- preview-modal-btn-right -->
                <!--<section class="invite-preview-header preview-topheader">
                <div class="row">
                    <div class="col-md-4">

                    </div>-->
                <!-- col-md-6 -->
                <!--<div class="col-md-8 d-flex align-items-center">
                <div class="invite-preview-right">
                    <button type="submit" class="theme-btn-lite">Publish & share</button>
                </div>-->
                <!-- col-md-6 -->
                <!--</div>
                    </div>
                </section>-->
                <h2>Hey There, I'm just a preview of what people will see. You can't edit me here or enter your information. Click to exit.</h2>

                <!--<div class="preview-bubble">
                    <p>Hey there, I’m just a preview. <br /> Click <b>Publish & share</b> to create your collection. <br /> Click the side arrows to see what you’ve setup.</p>
                </div>

                <div class="pointer-up">
                    <p>☝️</p>
                </div>

                <div class="pointer-right">
                    <p>👉</p>
                </div>-->

            </div>
        </div>
        <header v-if="isCollectionClosed" class="receipt-page-header">
            <div class="container">
                <div class="row">
                    <div class="col-sm-12">
                        <div class="logo">
                            <a href="/home/index">
                                <img width="150" :src="$getAssetUrlPlugin('siteres/gt-logo-b.svg')" alt="" title="logo" />
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </header>

        <div v-if="isCollectionClosed" class="mt-receipt-page text-center">
            <div class="mt-receipt-page-inner">
                <h1 id="thank-you-header">Thank You!</h1>
                <img class="img-fluid" :src="$getAssetUrlPlugin('siteres/receipt-pagev10.png')" alt="Alternate text" />
                <p>The collection for the group gift has closed but if you'd like to contribute, you can contact the organiser directly.</p>
                <a href="/Home/Index" class="theme-btn-lite receipt-page-btn">
                    Learn more
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right-short" viewBox="0 0 16 16">
                        <path fill-rule="evenodd" d="M4 8a.5.5 0 0 1 .5-.5h5.793L8.146 5.354a.5.5 0 1 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L10.293 8.5H4.5A.5.5 0 0 1 4 8z" />
                    </svg>
                </a>
            </div>
        </div>

        <div class="preview-modal-btn hidden" id="edit-modal-div">
        </div>

        <!-- SHARE -->
        <div v-if="mode === 'Share'" id="InvitationPageDiv" class="divdisplay collectiontop-space-first-section">
            <section class="invite-preview-header">
                <div class="row">
                    <div class="col-md-4">
                        <div class="invite-preview-left">
                            <h2 class="position-relative">
                                <a :href="BuildTrackUrl">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="20" viewBox="0 0 22 20" fill="none">
                                        <path d="M10.3829 18.3652L2 9.98238L10.3829 1.59953" stroke="#1E2437" stroke-width="2" stroke-miterlimit="10" />
                                        <path d="M2.01367 9.98242L21.1838 9.98242" stroke="#1E2437" stroke-width="2" stroke-miterlimit="10" />
                                    </svg>
                                </a>
                                Preview
                            </h2>
                        </div>
                    </div>
                    <!-- col-md-6 -->
                    <div class="col-md-8 d-flex align-items-center">
                        <div class="invite-preview-right">
                            <!--<form method="POST" asp-controller="Account" asp-action="SaveDraftCollection" asp-route-collection="@Model.CollectionGuid" asp-route-url="">-->
                            <a v-if="!hasSession" @click="moveNext('#Draft')" class="theme-btn-lite">
                                Publish
                                & share
                            </a>
                            <a v-else href="javascript:void(0)" target="_top" @click="moveNext('#collectionUrlFinal')" class="theme-btn-lite">Publish & share</a>

                            <a href="javascript:void(0)" class="theme-link-lite" @click="showEditModal">Edit details</a>

                            <!--</form>-->
                        </div>
                    </div>
                    <!-- col-md-6 -->
                </div>
            </section>
            <div class="preview-breadcrumbs ">
                <ul>
                    <li>
                        <a href="#">invite</a>
                    </li>
                    <li>
                        <i class="fas fa-chevron-right"></i>
                    </li>
                    <li>
                        <a href="javascript:void(0)" @click="showHideDiv('showGroupCard')">sign</a>
                    </li>
                    <li>
                        <i class="fas fa-chevron-right"></i>
                    </li>
                    <li>
                        <a href="javascript:void(0)" @click="showHideDiv('showPaymentScreen')">pay</a>
                    </li>
                </ul>
            </div>
            <section class="invite-preview-body invite-preview-divider preview-mode" style="margin-top:155px;" data-id="InvitationPageDiv">

                <div class="invite-preview-card-holder">
                    <div class="invite-preview-info">
                        <p class="border-bottom">
                            <span>From</span> Model.FromEmail
                        </p>
                        <p>
                            <span>Subject</span> Model.Subject
                        </p>
                    </div>

                    <div class="invite-preview-card">
                        <img class="card-bg" :src="collectionImage" alt="" />
                    </div>

                </div>
            </section>
        </div>
        <!-- END SHARE -->

        <div id="firstpagediv" class="divdisplay collectiontop-space-first-section">

            <!-- PREVIEW OR SHARE -->
            <section v-if="mode === 'Preview' || mode === 'Share'" class="invite-preview-header">
                <div class="row">
                    <div class="col-md-4 d-flex align-items-center">
                        <div class="invite-preview-left">

                            <!-- SHARE -->
                            <h2 v-if="mode === 'Share'" class="position-relative">

                                <a v-if="hasGroupCard" href="javascript:void(0)" @click="showHideDiv('showGroupCard')">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="20" viewBox="0 0 22 20" fill="none">
                                        <path d="M10.3829 18.3652L2 9.98238L10.3829 1.59953" stroke="#1E2437" stroke-width="2" stroke-miterlimit="10" />
                                        <path d="M2.01367 9.98242L21.1838 9.98242" stroke="#1E2437" stroke-width="2" stroke-miterlimit="10" />
                                    </svg>
                                </a>

                                <a v-else href="javascript:void(0)" @click="showHideDiv('InvitationPageDiv')">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="20" viewBox="0 0 22 20" fill="none">
                                        <path d="M10.3829 18.3652L2 9.98238L10.3829 1.59953" stroke="#1E2437" stroke-width="2" stroke-miterlimit="10" />
                                        <path d="M2.01367 9.98242L21.1838 9.98242" stroke="#1E2437" stroke-width="2" stroke-miterlimit="10" />
                                    </svg>
                                </a>

                                Preview
                            </h2>
                            <!-- END SHARE -->

                            <h2 v-else class="position-relative">
                                <a target="_top" :href="'/template/invitation?collection='+Guid">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="20" viewBox="0 0 22 20" fill="none">
                                        <path d="M10.3829 18.3652L2 9.98238L10.3829 1.59953" stroke="#1E2437" stroke-width="2" stroke-miterlimit="10" />
                                        <path d="M2.01367 9.98242L21.1838 9.98242" stroke="#1E2437" stroke-width="2" stroke-miterlimit="10" />
                                    </svg>
                                </a>
                                Preview
                            </h2>

                        </div>
                    </div>

                    <!-- col-md-4 -->
                    <div class="col-md-8 d-flex align-items-center">
                        <div class="invite-preview-right">

                            <a href="javascript:void(0)" v-if="!hasSession" @click="moveNext('#Draft')" class="theme-btn-lite">
                                Publish
                                & share
                            </a>
                            <a v-else href="javascript:void(0)" target="_top" @click="moveNext('#collectionUrlFinal')" class="theme-btn-lite">Publish & share</a>

                            <a href="javascript:void(0)" class="theme-link-lite" @click="showEditModal">Edit details</a>

                        </div>
                    </div>
                    <!-- col-md-6 -->
                </div>
            </section>

            <!-- END PREVIEW OR SHARE -->

            <div v-show="mode === 'Preview'" class="preview-breadcrumbs">
                <ul>
                    <li>
                        <a href="#" class="bdinvite" @click="showHideDiv('firstpagediv');" :class="{ active: isinviteActive }">invite</a>
                    </li>

                    <li v-show="hasGroupCard">
                        <i class="fas fa-chevron-right"></i>
                    </li>
                    <li v-show="hasGroupCard">
                        <a href="javascript:void(0)" class="bdsign" @click="showHideDiv('showGroupCard')" :class="{ active: issignActive }">sign</a>
                    </li>

                    <li v-show="!isGroupCardOnlyCollection">
                        <i class="fas fa-chevron-right"></i>
                    </li>
                    <li v-show="!isGroupCardOnlyCollection">
                        <a href="#" class="bdpay" @click="showHideDiv('showPaymentScreen')" :class="{ active: ispayActive }">pay</a>
                    </li>

                </ul>
            </div>

            <section class="mt-join-collection preview-bg" :class="previewClass">

                <div class="preview-modal-inner">


                    <div class="preview-main">

                        <div class="preview-modal-btn-right bdsign" v-if="!showGroupCardDiv && !showPaymentScreen">

                            <a v-if="hasGroupCard" href="javascript:void(0)" @click="showHideDiv('showGroupCard')">
                                <svg width="15" height="28" viewBox="0 0 16 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M2 26L14 14L2 2" stroke="#1E2437" stroke-width="4" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                            </a>

                            <a v-else href="javascript:void(0)" @click="showHideDiv('showPaymentScreen')">
                                <svg width="14" height="28" viewBox="0 0 16 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M2 26L14 14L2 2" stroke="#1E2437" stroke-width="4" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                            </a>

                        </div>


                        <div class="trigger-screen" @click="ShowhideDnone"></div>


                        <PreviewGroupCard v-if="showGroupCardDiv && collection.collectionId > 0"
                                          @show-hide-div="(x) => showHideDiv(x)"
                                          :has-session="hasSession"
                                          :has-group-card="hasGroupCard"
                                          :is-group-card-only="isGroupCardOnlyCollection"
                                          :inspirationTexts="inspirationTexts"
                                          :collection="collection"
                                          :mode="mode"
                                          :signonly="signonly"
                                          :messagedb="message"
                                          :isEditGC="isEditGC"
                                          :inv-id="this.$route.query.inviteeId"
                                          @showLoadScreen="showLoadScreen"
                                          @hideLoadScreen="hideLoadScreen"
                                          @GetGroupCardFrom="GetGroupCardFrom"
                                          @GetGroupCardMessage="GetGroupCardMessage"
                                          @GetGroupCardImageUrl="GetGroupCardImageUrl"
                                          @saveDraft="SaveDraftCollection" />

                        <ContributionPayment v-else-if="showPaymentScreen && collection.collectionId > 0"
                                             @show-hide-div="(x) => showHideDiv(x)"
                                             @move-Next="(x) => moveNext(x)"
                                             :collection-id="collection.collectionId"
                                             :close-date="collection.closeDate"
                                             :has-session="hasSession"
                                             @showLoadScreen="showLoadScreen"
                                             @hideLoadScreen="hideLoadScreen"
                                             @showErrorMessage="showErrorMessage"
                                             :mode="mode"
                                             :message="message"
                                             :has-group-card="hasGroupCard" />

                        <ContributionFirstPage v-else="!showGroupCardDiv && !showPaymentScreen && collection.collectionId > 0"
                                               @show-hide-div="(x) => showHideDiv(x)"
                                               :collection="collection"
                                               @showLoadScreen="showLoadScreen"
                                               @hideLoadScreen="hideLoadScreen" />
                    </div>

                </div>
                <!-- gtSignUp Modal -->
                <SignupPopup v-if="signup" @hideModal="hideModal"
                             @showLoadScreen="showLoadScreen"
                             @hideLoadScreen="hideLoadScreen" />
                <!-- gtSignUp Modal -->
            </section>
            <!-- errorModal -->
            <div class="modal fade gt-md-modal" id="spend-error-modal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div class="modal-dialog max-730" role="document">
                    <div class="modal-content">
                        <div class="modal-body p-0">
                            <div class="gt-md-modal-content">
                                <div class="text-center">
                                    <h2>Oops!</h2>
                                    <p class="mt-4">
                                        {{errorMessage}}
                                    </p>
                                    <div class="mt-4">
                                        <a href="javascript:void(0);" class="theme-btn-dark max-200" data-dismiss="modal">Ok</a>
                                    </div>
                                </div>
                            </div>
                            <!-- gt-md-modal-content -->
                        </div>
                        <!-- modal-body -->
                    </div>
                </div>
            </div>
            <!-- errorModal -->
            <!-- Loader -->
            <GTLoader ref="loader" />
        </div>
    </div>
</template>

<script>
    import ContributionFirstPage from "@/components/Contributor/ContributionFirstPage";
    import PreviewGroupCard from "@/components/GroupCard/PreviewGroupCard";
    import ContributionPayment from "@/components/Contributor/ContributionPayment";
    import SignupPopup from '../../common/SignupPopup.vue';
    import GTLoader from '@/common/GTLoader.vue';
    export default {
        name: "ContributionMain",
        components: { ContributionFirstPage, ContributionPayment, PreviewGroupCard, GTLoader, SignupPopup },
        data() {
            return {
                isdeclinee: true,
                isdecline: false,
                isEditGC: false,
                errorMessage: "",
                signonly: false,
                iscoleditmodal: false,
                displayLoader: false,
                signup: false,
                dnone: false,
                isinviteActive: true,
                issignActive: false,
                ispayActive: false,
                inspirationTexts: [],
                isCollectionClosed: false,
                hasSession: Boolean | false,
                checkCollectionStatus: false,
                mode: "",
                hasGroupCard: Boolean | true,
                topUp: '',
                isGroupCardOnlyCollection: false,
                showPaymentScreen: false,
                showGroupCardDiv: false,
                firstpagediv: false,
                collectionImage: String | '',
                previewClass: '',
                defaultOverlay: '',
                Guid: '',
                message: {
                    Id: 0,
                    From: "",
                    Message: "",
                    FirstName: "",
                    LastName: "",
                    ImageUrl: "",
                    ContriId: "",
                    Email: ""
                },
                collection: {
                    closeDate: '',
                    subtitle: '',
                    collectionSetupType: '',
                    zeroContributionAllowed: false,
                    totalCollectedContribution: 0,
                    totalCollectionTarget: 1,
                    collectionId: 0,
                    collectionImage: '',
                    collectionGuid: "",
                    soFarCollection: 0,
                    collectionTarget: 1
                },
            }
        },
        async mounted() {
            if (this.$route.query.topup == "topup")
                this.collection.collectionSetupType = "Collection";

            if (this.$route.query.gcid != "" && this.$route.query.gcid)
                this.showHideDiv('showGroupCard');
            await this.CheckCollectionStaus();
            await this.getModelData();
            await this.getInspirationText();
            this.messageChars = 0;
        },
        methods: {
            showErrorMessage(msg) {
                this.errorMessage = msg
                $('#spend-error-modal').modal({
                    backdrop: 'static',
                    keyboard: false
                })
            },
            showEditModal() {
                window.parent.showEditModal()
                this.iscoleditmodal = true;
            },
            showModal() {
                this.signup = true;
            },
            hideModal() {
                this.signup = false;
            },
            ShowhideDnone() {
                if (this.dnone == false) {
                    this.dnone = true;
                } else {
                    this.dnone = false;
                }
            },
            GetGroupCardFrom(firstName, lastName) {
                this.message.From = firstName + " " + lastName;
                this.message.FirstName = firstName;
                this.message.LastName = lastName;
            },
            GetGroupCardMessage(message) {
                this.message.Message = message;
            },
            GetGroupCardImageUrl(imageUrl) {
                this.message.ImageUrl = imageUrl;
            },
            async moveNext(url, returnUrl) {
                //loader
                /* this.$refs.loader.showLoadScreen();*/
                this.displayLoader = true;
                var ColGuid = this.$route.query.collection;

                if (this.hasSession) {
                    window.parent.$('#codeEmail').val(window.parent.$('#userName').val());
                    let self = this

                    await $.ajax({
                        url: "/Invite/SendInvitationEmailsV2",
                        data: JSON.stringify({ collectionId: self.collection.collectionId, btnType: "send-link", collectionTitle: self.collectionTitle, uniqueUrl: self.uniqueUrl }),
                        contentType: "application/json",
                        type: "POST",
                        success: function (result) {
                            if (result == "success") {
                                const url = `${window.location.origin}/track/index?collection=` + ColGuid;
                                window.parent.RedirectToUrl(url)
                            } else {
                                window.parent.showErrorPopup(result)
                            }
                        },
                        error: function (err) {
                            console.log(err)
                        }
                    });
                }
                else {
                    this.SaveDraftCollection("invite/share?collection=" + ColGuid);
                }
                this.displayLoader = false;
                /* this.$refs.loader.hideLoadScreen();*/
            },
            async SaveDraftCollection(Url) {
                /*this.$refs.loader.showLoadScreen();*/
                this.displayLoader = true;
                await $.ajax({
                    type: "POST",
                    url: "/Account/SaveDraft",
                    data: { url: Url },
                    success: function (result) {
                        if (result == "OK") {

                        }
                    },
                    error: function (err) {

                    }
                });
                this.signup = true;
                /*  this.$refs.loader.hideLoadScreen();*/
                this.displayLoader = false;

            },
            showLoadScreen() {
                this.$refs.loader.showLoadScreen();
            },
            async CheckCollectionStaus() {
                var col = this.collection;
                let mode = this.$route.query.mode
                let topup = this.$route.query.topup

                $.ajax({
                    type: "POST",
                    url: "/api/collectionservices/CheckCollectionStatus?collectionId=" + this.$route.query.collection,
                    contentType: "application/json",
                    data: { collectionId: col },
                    success: function (result) {
                        if (result.StatusCode === 302) {
                            if (mode) {
                                let redirectUrl = result.Message
                                if (!(mode === "Preview")) {
                                    if (topup === "topup")
                                        redirectUrl += "&topup=true"
                                    location.href = redirectUrl
                                } else {
                                    redirectUrl = result.Message.replace('contribute', 'preview')
                                    location.href = redirectUrl
                                }
                            }
                        } else {
                            if (result.Message == "Success") {
                                location.href = "Contributor/Unavailable";
                            }
                            else if (result.Message == "CollClosed") {
                                location.href = "Contributor/CollectionClosedOrSpentPage";
                            }
                            else {
                            }
                        }
                    },
                    error: function (err) {
                        console.log("Error while getting info.");
                    }
                });
            },
            hideLoadScreen() {
                this.$refs.loader.hideLoadScreen();
            },
            async getInspirationText() {
                await fetch('/api/collectionservices/getsuggestions?collection=' + this.collection.collectionGuid)
                    .then((res) => res.json())
                    .then((data) => {
                        this.inspirationTexts = data
                    })
                    .catch(err => console.log(this.card))
            },
            async getModelData() {
                var abc = this.$route.query.mode;
                const url = `${window.location.origin}/api/contributions/contribution-details?collection=${this.$route.query.collection}&mode=${this.$route.query.mode}&inviteeId=${this.$route.query.inviteeId}&res=${this.$route.query.res}&gcId=${this.$route.query.gcid}`;
                await this.axios.get(url)
                    .then((resp) => {
                        const {
                            IsNoThanks, Mode, CollectionGuid, CollectionId, HasGroupCard, HasSession, CloseDate, CollectionSubtitle,
                            IsDeletedCollection, IsForeignCollection, OrganiserName, CollectionSetupType, CollectionTarget, SoFarCollection, GroupCard, IsEditGC, ZeroContributionAllowed
                        } = resp.data;
                        if (IsNoThanks) {
                            this.isdecline = true;
                        }
                        else {
                            this.isdeclinee = false;
                            this.mode = Mode;
                            if (Mode == "Preview" || Mode == "Share") {
                                this.previewClass = "preview-mode";
                                this.defaultOverlay = "default-overlay";
                            }
                            if (this.$route.query.topup == "topup")
                                this.collection.collectionSetupType = "Collection";
                            else
                                this.collection.collectionSetupType = CollectionSetupType;

                            this.isGroupCardOnlyCollection = CollectionSetupType == "Group Card Only" ? true : false;

                            if (IsEditGC) {
                                this.message.Id = GroupCard.GCID
                                this.message.From = GroupCard.From
                                this.message.FirstName = GroupCard.FirstName
                                this.message.LastName = GroupCard.LastName
                                this.message.Message = GroupCard.Comment
                                this.message.ImageUrl = GroupCard.ImageURL
                                this.isEditGC = IsEditGC
                            }
                            if (this.isGroupCardOnlyCollection) {
                                this.signonly = true;
                            }
                            this.collection.zeroContributionAllowed = ZeroContributionAllowed;
                            this.collection.collectionTarget = CollectionTarget;
                            this.collection.soFarCollection = SoFarCollection;
                            this.hasGroupCard = HasGroupCard;
                            this.hasSession = HasSession;
                            this.collection.collectionId = CollectionId;
                            this.collection.closeDate = CloseDate;
                            this.collection.subtitle = CollectionSubtitle;
                            this.collection.collectionGuid = CollectionGuid;
                            this.Guid = this.collection.collectionGuid;
                        }
                    })
                    .catch((err) => {
                        console.error(err);
                        alert(err.response.data.errors);
                    }).finally(() => {

                    });
            },
            showHideDiv(divId) {
                window.parent.$('#editmodalhidden').val(divId)
                if (divId === "signonly") {
                    this.signonly = true;
                    this.showGroupCardDiv = true;
                    this.showPaymentScreen = false;
                    this.isinviteActive = false;
                    this.issignActive = true;
                    this.ispayActive = false;
                }
                else if (divId === "showGroupCard") {
                    if (this.isGroupCardOnlyCollection) {
                        this.signonly = true;
                    } else
                        this.signonly = false;
                    this.showGroupCardDiv = true;
                    this.showPaymentScreen = false;
                    this.isinviteActive = false;
                    this.issignActive = true;
                    this.ispayActive = false;

                } else if (divId === 'showPaymentScreen') {
                    this.showPaymentScreen = true;
                    this.showGroupCardDiv = false;
                    this.isinviteActive = false;
                    this.issignActive = false;
                    this.ispayActive = true;
                } else if (divId === "firstpagediv") {
                    this.firstpagediv = true;
                    this.showGroupCardDiv = false;
                    this.showPaymentScreen = false;
                    this.isinviteActive = true;
                    this.issignActive = false;
                    this.ispayActive = false;
                }
            },
            buildTrackUrl() {
                return `/Track/Index?collection=${this.collection}`;
            },
            buildTemplateInvitationUrl() {

                return `/template/invitation?collection=${this.collection.collectionGuid}`;
            }
        }
    }</script>

<style scoped>
</style>